interface Config {
  app: {
    mainColor: string;
    title: string;
    secondaryColor: string;
  },
  api: {
    baseUrl: string;
  };
  azure: {
    msal: {
      clientId: string;
      authority: string;
      redirectUri: string;
    };
    functionApp: {
      getDataFromGoogleSheetUrl: string;
      getDataFromOneDriveUrl: string;
      saveTimesheetUrl: string;
      updateTimesheetUrl: string;
      validateByHR: string;
      validateByForeman: string;
      getTimesheetsByUserUrl: string;
      deleteTimesheetUrl: string;
      getAllTimesheetsUrl: string;
      getForemanTimesheetsUrl: string;
      getHRTimesheetsUrl: string;
      exportTimesheetsUrl: string;
      purgeOldTimesheetsUrl: string;
    };
  };
  azureFunctionCLientId: string,
  nodeEnv: "production" | "development" | "test" | string;
}

const pick = (k: string) => (window.env?.[k] ?? process.env[k as any] ?? '').toString().trim();

const sanitizeColor = (v: string, fb = '#bc1e1c') => {
  // reject unresolved $(...) or empty/invalid strings
  if (!v || v.startsWith('$(')) return fb;
  const ok =
    /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v) ||
    /^rgba?\(/.test(v) || /^hsla?\(/.test(v);
  return ok ? v : fb;
};

const MAIN_COLOR = sanitizeColor(pick('REACT_APP_MAIN_COLOR'), '#bc1e1c');
const SECONDARY_COLOR = sanitizeColor(pick('REACT_APP_SECONDARY_COLOR'), '#7B1FA2');
const TITLE = pick('REACT_APP_TITLE') || 'React App';
const API_BASE_URL = pick('REACT_APP_API_BASE_URL') || 'http://localhost:7071';
const CLIENT_ID = pick('REACT_APP_FUNCTION_CLIENT_ID') || '';
const TENANT_ID = pick('REACT_APP_AZURE_TENANT_ID') || '';
const REDIRECT_URI = pick('REACT_APP_REDIRECT_URI') || window.location.origin;

const config: Config = {
  app: {
    mainColor: sanitizeColor(MAIN_COLOR, '#bc1e1c'),
    secondaryColor: sanitizeColor(SECONDARY_COLOR, '#7B1FA2'),
    title: TITLE || 'React App',
  },
  api: { baseUrl: API_BASE_URL || 'http://localhost:7071' },
  azure: {
    msal: {
      clientId: CLIENT_ID || '',
      authority: `https://login.microsoftonline.com/${TENANT_ID || ''}`,
      redirectUri: REDIRECT_URI || window.location.origin,
    },
    functionApp: {
      getDataFromGoogleSheetUrl: `/api/getDataFromGoogleSheets`,
      getDataFromOneDriveUrl: `/api/getDataFromOneDrive`,
      updateTimesheetUrl: `/api/updateTimesheet`,
      saveTimesheetUrl: `/api/saveTimesheet`,
      deleteTimesheetUrl: `/api/deleteTimesheet`,
      validateByHR: `/api/validateByHR`,
      validateByForeman: `/api/validateByForeman`,
      getTimesheetsByUserUrl: `/api/getTimesheetsByUser`,
      getAllTimesheetsUrl: `/api/getAllTimesheets`,
      getForemanTimesheetsUrl: `/api/getForemanTimesheets`,
      getHRTimesheetsUrl: `/api/getHRTimesheets`,
      exportTimesheetsUrl: `/api/exportTimesheets`,
      purgeOldTimesheetsUrl: `/api/purgeOldTimesheets`,
    },
  },
  azureFunctionCLientId: 'api://' + (CLIENT_ID || ''),
  nodeEnv: pick('NODE_ENV') || 'development',
};

export default config;
